import { commonjsGlobal as s } from "./index135.mjs";
import { __module as u } from "./index169.mjs";
u.exports;
(function(h) {
  (function(v, e, g) {
    function p(f) {
      var o = this;
      o.next = function() {
        var r = o.x, n = o.i, t, i;
        return t = r[n], t ^= t >>> 7, i = t ^ t << 24, t = r[n + 1 & 7], i ^= t ^ t >>> 10, t = r[n + 3 & 7], i ^= t ^ t >>> 3, t = r[n + 4 & 7], i ^= t ^ t << 7, t = r[n + 7 & 7], t = t ^ t << 13, i ^= t ^ t << 9, r[n] = i, o.i = n + 1 & 7, i;
      };
      function x(r, n) {
        var t, i = [];
        if (n === (n | 0))
          i[0] = n;
        else
          for (n = "" + n, t = 0; t < n.length; ++t)
            i[t & 7] = i[t & 7] << 15 ^ n.charCodeAt(t) + i[t + 1 & 7] << 13;
        for (; i.length < 8; ) i.push(0);
        for (t = 0; t < 8 && i[t] === 0; ++t) ;
        for (t == 8 ? i[7] = -1 : i[t], r.x = i, r.i = 0, t = 256; t > 0; --t)
          r.next();
      }
      x(o, f);
    }
    function a(f, o) {
      return o.x = f.x.slice(), o.i = f.i, o;
    }
    function c(f, o) {
      f == null && (f = +/* @__PURE__ */ new Date());
      var x = new p(f), r = o && o.state, n = function() {
        return (x.next() >>> 0) / 4294967296;
      };
      return n.double = function() {
        do
          var t = x.next() >>> 11, i = (x.next() >>> 0) / 4294967296, l = (t + i) / (1 << 21);
        while (l === 0);
        return l;
      }, n.int32 = x.next, n.quick = n, r && (r.x && a(r, x), n.state = function() {
        return a(x, {});
      }), n;
    }
    e && e.exports ? e.exports = c : this.xorshift7 = c;
  })(
    s,
    h
  );
})(u);
var b = u.exports;
export {
  b as x
};
